<template>
  <div class="sign-up">
    <p>{{ $t('driver_onboarding.step_progress_bar.step', { num: $route.meta.step_id }) }}</p>
    <h1>{{ $t('driver_onboarding.auth.signup') }}</h1>

    <div class="form--sign_up">
      <div class="field">
        <InputField
          type="text"
          minlength="2"
          name="username"
          :labelName="$t('driver_onboarding.auth.name')"
          @onChange="onChangeUsername"
          :errorMessage="errorMessageUsername"
          :showError="showErrorUsername"
        />
      </div>

      <div class="field">
        <div class="has-prepend">
          <div class="prepend-input">
            <img src="/img/onboard-driver/vn-flag.svg" alt />
            <input value="+84" disabled />
          </div>
          <InputField
            type="text"
            name="mobile"          
            :labelName="$t('driver_onboarding.auth.mobile')"
            @onChange="onChangeMobile"
          />
        </div>
        <span class="error-mobile" v-if="showErrorMobile">{{errorMessageMobile}}</span>
      </div>

      <div class="field">
        <InputField
          type="text"
          name="email"
          :labelName="$t('driver_onboarding.auth.email')"
          @onChange="onChangeEmail"
          :errorMessage="errorMessageEmail"
          :showError="showErrorEmail"
        />
      </div>

      <div class="field">
        <InputField
          type="text"
          name="referral"
          :labelName="$t('driver_onboarding.auth.referral')"
          @onChange="onChangeRef"
          :errorMessage="errorMessageRef"
          :showError="showErrorRef"
        />
      </div>

      <b-button @click.prevent="onSubmit" :disabled="loading" :loading="loading">
        {{ $t('driver_onboarding.auth.submit') }}
      </b-button>

      <div class="button--sign_in">
        <span>{{ $t('driver_onboarding.auth.already') }}</span>
        <br />
        <b-button @click="switchToSignIn">{{ $t('driver_onboarding.auth.signin') }}</b-button>
      </div>
    </div>

    <b-loading :is-full-page="isFullPage" :active.sync="loading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import InputField from "@/components/InputField.vue";
import {mapGetters} from "vuex"

export default {
  components: {
    InputField
  },
  data() {
    return {
      username: null,
      mobile: null,
      email: null,
      referralCode: "",
      countryCode: "VN",

      errorMessageUsername: "",
      errorMessageMobile: "",
      errorMessageEmail: "",
      errorMessageRef: "",

      showErrorUsername: false,
      showErrorMobile: false,
      showErrorEmail: false,
      showErrorRef: false,

      loading: false,
      spinLoading: false,
      isFullPage: true
    };
  },  
  computed: {
    ...mapGetters(['supplierToken']),

  },
  methods: {
    switchToSignIn() {
      this.$router.push({
        name: 'signin'
      })

      this.$gtag('event',this.$trackingEvents.EVENTS.SWITCH_SIGN_IN, {'event_category' : this.$route.path})

    },
    onChangeUsername(value) {
      if (this.showErrorUsername) {
        this.showErrorUsername = false;
      }

      if (value.length > 2) {
        this.username = value;
      } else {
        this.showErrorUsername = true;
        this.errorMessageUsername = "Vui lòng nhập nhiều hơn 2 ký tự";
      }
    },
    onChangeMobile(value) {
      if (this.showErrorMobile) {
        this.showErrorMobile = false;
      }
      if (value) {
        var cleanedValue =
          typeof value === "string" ? value.trim() : value.toString();
        const pattern = /^\+\d+$|^\d+$/;
        const isNumber = pattern.test(cleanedValue);
        if (
          isNumber &&
          ((cleanedValue.charAt(0) === "+" && cleanedValue.length > 5) ||
            (cleanedValue.charAt(0) !== "+" && cleanedValue.length > 4)) &&
          cleanedValue.length < 14
        ) {
          this.isVerifyPhoneCode = true;
          this.mobile = value;
        } else {
          this.showErrorMobile = true;
          this.errorMessageMobile = "Số điện thoại không hợp lệ";
        }
      } else {
        this.showErrorMobile = true;
        this.errorMessageMobile = "Vui lòng nhập số điện thoại";
      }
    },
    onChangeEmail(value) {
      if (this.showErrorEmail) {
        this.showErrorEmail = false;
      }
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isMail = pattern.test(value);

      if (isMail) {
        this.email = value;
      } else {
        this.showErrorEmail = true;
        this.errorMessageEmail =
          "Định dạng email bao gồm ký tự '@' và tên nhà cung cấp như @hotmail.com, @gmail.com...";
      }
    },
    onChangeRef(value) {
      if (this.showErrorRef) {
        this.showErrorRef = false;
      }
      this.referralCode = value;
    },
    onSubmit() {
      if (this.mobile === null || this.name === null || this.email === null) {
        this.$buefy.notification.open({
          message: "Trường tên, số điện thoại và email là bắt buộc!",
          type: "is-danger",
          duration: 3000,
          position: "is-bottom"
        });
        return false;
      }

      const data = {
        mobile: this.mobile,
        name: this.username,
        email: this.email,
        referral_code: this.referralCode,
        country_code: this.countryCode
      };
      if (
        !this.showErrorMobile &&
        !this.showErrorUsername &&
        !this.showErrorEmail
      ) {
        this.loading = true;

        this.$store
          .dispatch("driverSignUp", data)
          .then(res => {
            if (res && res.status === 200) {
              this.loading = false;
              this.$store.dispatch("updateStatusSignUp", false);
              this.$store.dispatch("updateStatusSignInStep1", true);

              this.$router.push({
                name: 'signin',
                query: { id: res.data.id }
              })
            }
          })
          .catch(error => {
            this.loading = false;
            if (error) {
              switch (error.status) {
                case 409:
                  if (error.data.title === "Email existed") {

                    this.showErrorEmail = true;
                    this.errorMessageEmail = this.$t('driver_onboarding.message.email_existed');
                    
                  } else if ( error.data.title === "Mobile number existed") {

                    this.showErrorMobile = true;
                    this.errorMessageMobile = this.$t('driver_onboarding.message.mobile_existed')

                  } else if (error.data.title === "Mobile number not valid") {

                    this.showErrorMobile = true;
                    this.$t('driver_onboarding.message.mobile_not_valid')

                  }
                  break;
                case 404:
                  if (error.data.title === "Referral code does not exist") {
                    this.showErrorRef = true;
                    this.errorMessageRef =
                      this.$t('driver_onboarding.message.ref_not_valid');
                  }
                  break;
                case 406: {
                  if (error.data.title === "Email not valid") {
                    this.showErrorEmail = true;
                    this.errorMessageEmail = this.$t('driver_onboarding.message.email_not_valid');
                  } else if (error.data.title === "Mobile number not valid") {
                    this.showErrorMobile = true;
                    this.errorMessageMobile = this.$t('driver_onboarding.message.mobile_not_valid');
                  }
                  break;
                }
                default:
                  this.$buefy.notification.open({
                    message: error.data.description,
                    type: "is-danger",
                    duration: 3000,
                    position: "is-bottom"
                  });
              }
            }
          });
      }
    }
  },
  mounted() {
    if(this.supplierToken){
      this.$router.push({name : 'document'})
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-up {
  p:first-child {
    color: #bcbcbc;
    font-size: 16px;
    margin-bottom: 4px;
    font-weight: 500;
  }
  h1 {
    margin: 0 0 40px 0;
    color: #1a1a1a;
  }
  .button {
    width: 150px;
    height: 48px;
    font-weight: 500;
  }
  .form--sign_up {
    width: 300px;
    margin-bottom: 24px;

    .field {
      // height: 46px;
      margin-bottom: 15px;

      .prepend-input {
        display: flex;
        width: 25%;
        padding: 0 10px;

        input {
          background-color: #f2f2f2;
          border: none;
          outline: none;
          font-size: 16px;
          padding: 0 5px;
        }
      }
    }

    .field {
      .has-prepend {
        display: flex;
        background-color: #f2f2f2;
        border-radius: 4px;
        height: 46px;
      }
      .error-mobile{
        font-size: 12px;
        color: #ff5252;
      } 
    }

    .button {
      background-color: #ff8200;
      color: #fff;
      border-color: inherit;
      border-radius: 4px;
    }

    .button--sign_in {
      margin-top: 24px;
      span {
        color: #7a8189;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .button {
        background-color: #fff;
        color: #ff8200;
        border-color: #ff8200;
        margin-top: 10px;
        border-radius: 2px;
      }
    }

   
  }
}
</style>
